/**
 * mainLocalisation.js
 */
require.config({
    baseUrl: "../../../../../"
});

require([
    "jquery", "bootstrap", "geolocController", "moment"
],
        function () {
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

define("mainLocalisation", function(){});

